import React, { useEffect } from "react";
import { Form, Input, Button } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { doForgotPassword } from "../../../modules/auth/stores/thunk";
import "./Auth.scss";

const isNordicrouting = window.location.origin.includes("nordicrouting.se");
const lang = isNordicrouting ? "se" : "en"; // Adjust logic here for additional languages

const text = {
  en: {
    resetPassword: "Reset Password",
    enterEmail: "Enter your email address to receive reset password instructions",
    workEmail: "Work Email",
    invalidEmail: "Invalid Email",
    required: "Required",
    sendResetLink: "Send reset password link",
  },
  se: {
    resetPassword: "Återställ lösenord",
    enterEmail: "Ange din e-postadress för att få instruktioner om att återställa lösenordet",
    workEmail: "Arbets-E-post",
    invalidEmail: "Ogiltig e-post",
    required: "Obligatorisk",
    sendResetLink: "Skicka länk för återställning av lösenord",
  },
};

const ForgotPasswordForm = ({ history }) => {
  const dispatch = useDispatch();
  const { message } = useSelector(state => state.common);

  useEffect(() => {
    if (message) {
      history.push("/");
    }
  }, [message]);

  const handleSubmit = params => {
    dispatch(doForgotPassword(params));
  };

  return (
    <div className="ForgotPasswordForm">
      <Form scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
        <div className="Logo">
          <Link to="/">
            <img src={`/logo-${isNordicrouting ? "nordicrouting" : "parcelizer"}.svg`} alt="logo" />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">{text[lang].resetPassword}</div>
          <div className="SubTitle">{text[lang].enterEmail}</div>
        </div>
        <div className="FormContent">
          <Form.Item
            label={text[lang].workEmail}
            name="email"
            hasFeedback
            rules={[
              { type: "email", message: text[lang].invalidEmail },
              { required: true, message: text[lang].required },
            ]}>
            <Input size="large" placeholder="name@company.com" />
          </Form.Item>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            {text[lang].sendResetLink}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ForgotPasswordForm;
